
// api service calls should be written here (Service ajax calls are managed using Using Axios Library)

/*Example:
 export const fetchPosts = () => {
 return axios.get(window.baseUrl + '/users');
 }*/


export const ChangePassword=(model)=>{

  return $.post('Account/ChangePassword', model)

}



// WEBPACK FOOTER //
// ./src/components/header/header.service.js